<div mat-dialog-title>Important Disclosure</div>
<mat-dialog-content>
    <mat-card class="info block">
        <mat-card-subtitle>
            <div style='font-weight:normal'>
                <strong>You are now being directed to a third-party website that is owned and operated by FinMason.</strong> Schwab is not responsible for the content on this website and does not edit or endorse any of the content. FinMason is wholly responsible for the content and features found on their site. Therefore, this should not be considered a recommendation by Schwab. Schwab does not guarantee that the site is accurate, complete or timely, nor does Schwab make any warranties to you regarding any results from using the third-party.
            </div>
        </mat-card-subtitle>
    </mat-card>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn-medium-secondary" (click)="close()">Cancel</button>
    <button class="btn-medium-primary" (click)="getFimasonToken()">Continue</button>
</mat-dialog-actions>
